
<template>
	<main>
		<div class="container-fluid">
			
			<div class="m-show m-header-bar">

				<div class="fc-bet">
					<div style="padding:10px">
						<img src="@/assets/logo.png" alt=""  style="height: 40px;">
					</div>
					<div style="padding:10px">
						<label class="btn btn-blue" style="font-size: 12px;" @click="toHome">返回</label>
					</div>
				</div>
				
			</div>

			<div style="padding-top: 60px;">

        <video :src="url" controls class="w-100 block" style="background: #000;"></video>

      </div>
		</div>
	</main>
</template>

<script>

export default {
	
	data() {
		return {
			url:""
		};
	},
	methods: {
    toHome() {
      this.$router.push({
				path: '/'
			})
    }
  },
};
</script>

<style>
body {
	background: #f5f6f7;
}

.form-check{
	position:relative;
}
.accordion-body .form-check{
	padding-left: 0;
}
.accordion-body .form-check input{
	position: absolute;
	left: 1.2em;
	top: 50%;
	margin-top: 0;
	transform: translateY(-50%);
}
.accordion-body .form-check label{
	position: relative;
	z-index: 5;
	margin-left: -.5em;
	padding-left: 1.5em;
}

.downImgMask{
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 1999999;
	background: rgba(0, 0, 0, .75);
	display: flex;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	font-size: 30px;
	color: #fff;font-weight: bold;
}
.downImgMask img{
	width: 90%;
	height: 80%;
	object-fit: contain;
}



.m-show{
	display: none!important;
}
@media (max-width:1000px) {
	.m1000-hide{
		display: none!important
	}
	
}


.m-header-bar{
	position: fixed;
	left: 0;top: 0;
	right: 0;
	z-index: 99999;
	background: #fff;
}

@media (max-width: 575px) {
    .m-hide{
		display: none!important;;
	}
	.m-show{
		display: block!important;
	}
	.m-btns-box{
		position: fixed;
		z-index: 99;
		right: 5px;
		top: 100vw;
		margin-top: 15px;
		display: none!important;;
		flex-direction: column;
		justify-items: right;
		
	}
	.m-btns-box .d-flex{
		flex-direction: column;		
		justify-items: right;
	}
	.m-btns-box .btn{
		margin-bottom: 10px;
	}
	.m-btns-box #new-btn{
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding: 5px!important;
	}
	.m-btns-box #new-btn svg{
		margin: 5px;
	}
	.m-screen{
		padding-left: 0;
		padding-right: 0;
	}
	#image-export-btn{
		position: fixed;
		right: 0;
		margin-right: 5px!important;
		bottom: 0px;
		z-index: 66;
		display: none;
	}
	#stage-wrapper{
		position: fixed;
		z-index: 66;
		left: 0;	
		top: 113px;
		width: 100%;
		background: #fff;
	}
	.options-box{
		padding-top: calc(100vw + 113px);
	}
	#pathology-list{
		height: auto;
		overflow: visible;
		padding-bottom: 20px;
	}
}




</style>
